import { api } from './api';

export type PublicCsatStatus = 'pending' | 'opened' | 'completed' | 'expired' | 'unavailable';

export interface PublicCsatSurvey {
  status: PublicCsatStatus;
  message: string;
  displayType: 'star' | 'emoji' | 'number';
  askComment: boolean;
  submittedRating?: number | null;
  submittedFeedback?: string | null;
}

export interface PublicCsatSubmitRequest {
  rating: number;
  feedback?: string | null;
}

export interface PublicCsatSubmitResult {
  status: string;
  rating: number;
  feedback?: string | null;
  alreadyCompleted: boolean;
}

class PublicCsatService {
  async getSurvey(conversationUuid: string): Promise<PublicCsatSurvey> {
    const response = await api.get<PublicCsatSurvey>(`/public/csat/${conversationUuid}`);
    return response.data;
  }

  async markOpened(conversationUuid: string): Promise<void> {
    await api.post(`/public/csat/${conversationUuid}/open`);
  }

  async submit(conversationUuid: string, request: PublicCsatSubmitRequest): Promise<PublicCsatSubmitResult> {
    const response = await api.patch<PublicCsatSubmitResult>(`/public/csat/${conversationUuid}`, request);
    return response.data;
  }
}

export const publicCsatService = new PublicCsatService();
